// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"51ebd832","381":"6dcf548d","657":"1d87ecfe","793":"9c35a8f1","802":"bfcbe35c","819":"2c675f93","868":"9e324ae7","885":"712a3538"}[chunkId] + ".chunk.css";
};